module.exports = __webpack_public_path__ + "img/image-132.96fc4d18.jpg";